import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const BUSINESS_NETWORK_LAUNCH_EVENT_ID = "business-network-2026-09-30";
export const BUSINESS_NETWORK_LAUNCH_KEY = BUSINESS_NETWORK_LAUNCH_EVENT_ID;
export const BUSINESS_NETWORK_LAUNCH_NAME = "Urban Unity Business Network Launch Event";

export const BUSINESS_NETWORK_SOURCES = [
  "business-network-launch-page",
  "business-network-event-page",
  "business-network-hub",
  "homepage",
  "community-page",
  "poster-qr",
  "facebook",
  "instagram",
  "linkedin",
  "email",
  "whatsapp",
  "partner",
  "direct",
  "website",
  "unknown",
];

export const EMPTY_BUSINESS_NETWORK_REGISTRATION = {
  firstName: "",
  lastName: "",
  email: "",
  businessOrganisation: "",
  roleOrJobTitle: "",
  phone: "",
  previousBusinessNetworkAttendee: null,
  eventConsent: false,
  marketingConsent: false,
  website: "",
};

const clean = (value) => String(value || "").trim();

export function normaliseBusinessNetworkSource(value) {
  const source = clean(value).toLowerCase();
  return BUSINESS_NETWORK_SOURCES.includes(source)
    ? source
    : "unknown";
}

export function validateBusinessNetworkRegistration(values = {}) {
  const errors = {};
  const firstName = clean(values.firstName);
  const lastName = clean(values.lastName);
  const email = clean(values.email);
  const businessOrganisation = clean(values.businessOrganisation);
  const roleOrJobTitle = clean(values.roleOrJobTitle);
  const phone = clean(values.phone);

  if (firstName.length < 1 || firstName.length > 80) {
    errors.firstName = "Enter your first name (up to 80 characters).";
  }
  if (lastName.length < 1 || lastName.length > 80) {
    errors.lastName = "Enter your last name (up to 80 characters).";
  }
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 254) {
    errors.email = "Enter a valid email address.";
  }
  if (businessOrganisation.length < 2 || businessOrganisation.length > 160) {
    errors.businessOrganisation = "Enter a business or organisation name between 2 and 160 characters.";
  }
  if (roleOrJobTitle.length > 120) {
    errors.roleOrJobTitle = "Keep the role or job title to 120 characters or fewer.";
  }
  if (phone && (phone.length < 7 || phone.length > 40)) {
    errors.phone = "Enter a valid phone number, or leave this field blank.";
  }
  if (typeof values.previousBusinessNetworkAttendee !== "boolean") {
    errors.previousBusinessNetworkAttendee = "Choose Yes or No.";
  }
  if (values.eventConsent !== true) {
    errors.eventConsent = "Confirm that UUN may use these details to manage your event registration.";
  }

  return errors;
}

function eventIdentity(event = {}) {
  return {
    eventId: clean(event.id || event.eventId) || BUSINESS_NETWORK_LAUNCH_EVENT_ID,
    eventName:
      clean(event.title || event.eventName || event.name) || BUSINESS_NETWORK_LAUNCH_NAME,
  };
}

export function buildBusinessNetworkRegistrationPayload(values, source, event = {}) {
  const identity = eventIdentity(event);
  return {
    eventId: identity.eventId,
    eventName: identity.eventName,
    firstName: clean(values.firstName),
    lastName: clean(values.lastName),
    email: clean(values.email),
    businessOrganisation: clean(values.businessOrganisation),
    roleOrJobTitle: clean(values.roleOrJobTitle),
    phone: clean(values.phone),
    previousBusinessNetworkAttendee:
      values.previousBusinessNetworkAttendee === true,
    eventConsent: values.eventConsent === true,
    marketingConsent: values.marketingConsent === true,
    registrationSource: normaliseBusinessNetworkSource(source),
    honeypot: clean(values.website),
  };
}

export async function submitBusinessNetworkRegistration(values, source, event = {}) {
  const errors = validateBusinessNetworkRegistration(values);
  if (Object.keys(errors).length > 0) {
    const error = new Error("BUSINESS_NETWORK_REGISTRATION_INVALID");
    error.validationErrors = errors;
    throw error;
  }

  // The existing callable name is retained for deployed-client compatibility;
  // the server validates the supplied published Business Network event.
  const register = httpsCallable(functions, "registerBusinessNetworkLaunch");
  const response = await register(
    buildBusinessNetworkRegistrationPayload(values, source, event)
  );
  return response.data;
}
